import React, { useContext, useState } from 'react';
import { NotebookContext } from '../../../context/NotebookContext';
import { UserContext } from '../../../context/UserContext';
import client from '../../../lib/client';
import ErrorMessages from '../../ErrorMessages';
import { Input } from '../../forms';
import { Button, Card, CardSegment } from '../../ui';
import { ErrorMessagesArray } from '../tracker/types';
import {
  EditAccountMembership,
  EditAccountMembershipVariables
} from '../../../queries/__generated__/EditAccountMembership';
import { editAccountMembership, accountMembersQuery } from '../../../queries/account';
import { Query } from 'react-apollo';
import {
  AccountMembersQuery,
  AccountMembersQueryVariables
} from '../../../queries/__generated__/AccountMembersQuery';
import { ErrorScreen } from '../../utils';
import { find } from 'lodash';
import { toast } from 'react-toastify';

interface AccountProfileProps {
  account: {
    id: string;
  };
}

const AccountMemberProfile: React.FC<AccountProfileProps> = ({ account }) => {
  const { user } = useContext(UserContext);
  const { reloadNotebook } = useContext(NotebookContext);
  const [displayName, setDisplayName] = useState('');
  const [errors, setErrors] = useState<ErrorMessagesArray>([]);

  async function saveProfile() {
    if (displayName) {
      const res = await client.mutate<EditAccountMembership, EditAccountMembershipVariables>({
        mutation: editAccountMembership,
        variables: {
          input: {
            memberId: user.memberIdForAccount(account.id),
            displayName
          }
        }
      });

      if (res!.data!.editAccountMembership.errors) {
        setErrors(res.data!.editAccountMembership.errors);
        return;
      }
      if (errors.length) {
        setErrors([]);
      }

      toast(`Display name updated!`, { type: 'success' });
      reloadNotebook();
    }
  }

  return (
    <Query<AccountMembersQuery, AccountMembersQueryVariables>
      query={accountMembersQuery}
      variables={{ input: { accountId: account.id } }}
    >
      {({ data, loading, error }) => {
        if (loading) {
          return <div />;
        }
        if (error) {
          return <ErrorScreen error={error.message} />;
        }

        const accountMembers = data!.accountMembers;

        const currentAccountMember = find(
          accountMembers,
          m => m.id === user.memberIdForAccount(account.id)
        );

        return (
          <Card className="mb2">
            <CardSegment className="pa4">
              <ErrorMessages errors={errors} />

              <Input
                label="Your Display Name"
                className="mb3"
                defaultValue={currentAccountMember!.displayName}
                onChange={e => setDisplayName(e.target.value)}
                placeholder="Your display name for this account..."
                data-testid="member-display-name-input"
              />

              <Button onClick={saveProfile} data-testid="member-save-button">
                Save
              </Button>
            </CardSegment>
          </Card>
        );
      }}
    </Query>
  );
};

export default AccountMemberProfile;
